var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxUncheckedNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_23845_21332",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H14C17.3137 0 20 2.68629 20 6V14C20 17.3137 17.3137 20 14 20H6C2.68629 20 0 17.3137 0 14V6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H14C17.3137 0 20 2.68629 20 6V14C20 17.3137 17.3137 20 14 20H6C2.68629 20 0 17.3137 0 14V6Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0V1H14V0V-1H6V0ZM20 6H19V14H20H21V6H20ZM14 20V19H6V20V21H14V20ZM0 14H1V6H0H-1V14H0ZM6 20V19C3.23858 19 1 16.7614 1 14H0H-1C-1 17.866 2.13401 21 6 21V20ZM20 14H19C19 16.7614 16.7614 19 14 19V20V21C17.866 21 21 17.866 21 14H20ZM14 0V1C16.7614 1 19 3.23858 19 6H20H21C21 2.13401 17.866 -1 14 -1V0ZM6 0V-1C2.13401 -1 -1 2.13401 -1 6H0H1C1 3.23858 3.23858 1 6 1V0Z",
    fill: "white",
    fillOpacity: 0.3,
    mask: "url(#path-1-inside-1_23845_21332)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUncheckedNew);
export default __webpack_public_path__ + "static/media/checkbox_unchecked_new.0c2df1444a4fb85ebf6ef2764bb462a5.svg";
export { ForwardRef as ReactComponent };